const updateCreatorProduct = (state, { payload: { product } }) => {
	state.creatorProduct = product;
};

export default updateCreatorProduct;
